import * as redux from 'redux';
import { routerReducer } from 'react-router-redux'
import loginReducer from './loginPage';
import appConfigReducer from './appConfigs';
import projectReducer from './project';
import companyReducer from './company';
import jobCardReducer from './jobCard';
import registerUserReducer from './registerUser';
import myWorkspaceReducer from './myWorkspace';
import usersReducer from './users'
import audits from './audit';
import stockControllerReducer from './stockController';


export default function createRootReducer() {
  return redux.combineReducers({
    routing: routerReducer,
    loginState: loginReducer,
    appConfigState: appConfigReducer,
    projectState: projectReducer,
    companyState: companyReducer,
    jobCardState: jobCardReducer,
    registerUserState: registerUserReducer,
    myWorkspaceState: myWorkspaceReducer,
    usersState: usersReducer,
    jobAuditState: audits,
    stockControllerState: stockControllerReducer,
  });
}
